import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "actions/index";
import ModalError from "components/UI/Modal/ModalError";
import ModalSuccess from "components/UI/Modal/ModalSuccess";
import videoBackground from "../../../video/video.mp4";
import "./lunchTeamMainPresentation.scss";

class LunchTeamMainPresentation extends Component {
  componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }

  escFunction = event => {
    if (event.keyCode === 27) {
      this.props.onCloseModalError();
    }
  };

  handleCloseModalSuccess = () => {
    window.location.assign("/");
  };

  render() {
    return (
      <div className="secao-1">
        <div className="overlay-video" />
        <video preload="auto" autoPlay muted loop nocontrols="" playsInline>
          <source src={videoBackground} type="video/mp4" />
        </video>
        <div className="wrap">
          <div className="centerer">
            <h1>Your one-stop team for office lunch delivery</h1>
            <a
              onClick={() => this.props.onToggleRegisterCompany(true)}
              className="bt get-more-info"
            >
              Find out more or register your company
            </a>
          </div>
        </div>
        <ModalError
          style={{ zIndex: "99999", position: "absolute", margin: "5% 40%" }}
          errorMessage={this.props.errorMessage}
          showModal={this.props.error}
          closeModal={this.props.onCloseModalError}
          styleContent={{ color: "gray" }}
        />
        <ModalSuccess
          message={"Check your email to reset your password."}
          showModal={this.props.isRequestSentEmailResetPasswordSuccess}
          closeModal={this.props.onCloseRequestEmailResetPasswordModal}
        />
        <ModalSuccess
          showModal={this.props.showSuccessModalRegister}
          message={"Thank you for registering! Check your email."}
          closeModal={this.handleCloseModalSuccess}
        />{" "}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onCloseModalError: () => dispatch(actions.closeModalError()),
    onCloseRequestEmailResetPasswordModal: () =>
      dispatch(actions.onCloseRequestEmailResetPasswordModal()),
    onToggleRegisterCompany: toggle =>
      dispatch(actions.toggleRegisterCompany(toggle))
  };
};

const mapStateToProps = state => {
  return {
    isRequestSentEmailResetPasswordSuccess:
      state.passwordReducer.isRequestSentEmailResetPasswordSuccess,
    error: state.signupReducer.error,
    errorMessage: state.signupReducer.errorMessage,
    showSuccessModalRegister: state.landingReducer.showSuccessModal
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LunchTeamMainPresentation);



// WEBPACK FOOTER //
// ./src/containers/Landing/LunchTeamMainPresentation/index.js